var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mx-0",
    attrs: {
      "flat": ""
    }
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    ref: "startTextField",
    attrs: {
      "label": "C1.1: Name",
      "rules": _vm.noNumberAndRequiredRules,
      "outlined": ""
    },
    model: {
      value: _vm.registration.name,
      callback: function callback($$v) {
        _vm.$set(_vm.registration, "name", $$v);
      },
      expression: "registration.name"
    }
  }), _c('v-text-field', {
    attrs: {
      "rules": _vm.noNumberRules,
      "label": "C1.2: Vorname",
      "outlined": ""
    },
    model: {
      value: _vm.registration.firstname,
      callback: function callback($$v) {
        _vm.$set(_vm.registration, "firstname", $$v);
      },
      expression: "registration.firstname"
    }
  }), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.day,
      "rules": _vm.requiredRules,
      "label": "I: Tag (DD)",
      "hint": "Erstzulassungsdatum",
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: _vm.registration.firstregistrationDay,
      callback: function callback($$v) {
        _vm.$set(_vm.registration, "firstregistrationDay", $$v);
      },
      expression: "registration.firstregistrationDay"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "rules": _vm.requiredRules,
      "label": "I: Monat (MM)",
      "items": _vm.month,
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: _vm.registration.firstregistrationMonth,
      callback: function callback($$v) {
        _vm.$set(_vm.registration, "firstregistrationMonth", $$v);
      },
      expression: "registration.firstregistrationMonth"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "rules": _vm.requiredRules,
      "label": "I: Jahr",
      "items": _vm.year,
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: _vm.registration.firstregistrationYear,
      callback: function callback($$v) {
        _vm.$set(_vm.registration, "firstregistrationYear", $$v);
      },
      expression: "registration.firstregistrationYear"
    }
  })], 1)], 1), _c('v-text-field', {
    attrs: {
      "rules": _vm.requiredRules,
      "type": "number",
      "label": "3: Prüfziffer",
      "outlined": ""
    },
    on: {
      "keyup": _vm.validate
    },
    model: {
      value: _vm.isChecksum,
      callback: function callback($$v) {
        _vm.isChecksum = $$v;
      },
      expression: "isChecksum"
    }
  }), _c('v-text-field', {
    ref: "fin",
    staticClass: "code",
    attrs: {
      "label": "E: FIN",
      "counter": "17",
      "rules": _vm.vinRules,
      "suffix": _vm.getChecksumText,
      "outlined": ""
    },
    on: {
      "keyup": _vm.uppercase,
      "blur": _vm.checkfin
    },
    model: {
      value: _vm.fin,
      callback: function callback($$v) {
        _vm.fin = $$v;
      },
      expression: "fin"
    }
  }), _c('v-autocomplete', {
    attrs: {
      "rules": _vm.requiredRules,
      "label": "10: Antriebsart",
      "outlined": "",
      "cache-items": "",
      "items": _vm.driveType
    },
    model: {
      value: _vm.registration.driveTyp,
      callback: function callback($$v) {
        _vm.$set(_vm.registration, "driveTyp", $$v);
      },
      expression: "registration.driveTyp"
    }
  }), _c('v-autocomplete', {
    attrs: {
      "label": "J: Fahrzeugklasse",
      "rules": _vm.requiredRules,
      "outlined": "",
      "cache-items": "",
      "items": _vm.vehicleClass,
      "item-text": "showText",
      "item-value": "value"
    },
    model: {
      value: _vm.registration.vehicleClass,
      callback: function callback($$v) {
        _vm.$set(_vm.registration, "vehicleClass", $$v);
      },
      expression: "registration.vehicleClass"
    }
  }), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "disabled": !_vm.valid,
      "flat": "",
      "block": "",
      "x-large": "",
      "loading": _vm.loading,
      "color": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Fahrzeugdaten bestätigen")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }